/**
 * @generated SignedSource<<13d1c89e6c3c95a7fdbe4bc2755f96a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionDetail_AsyncEditableVersionDescription$data = {
  readonly description: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"editableVersionDescription_softwareReleasesVersionDetail">;
  readonly " $fragmentType": "async_softwareReleasesVersionDetail_AsyncEditableVersionDescription";
};
export type async_softwareReleasesVersionDetail_AsyncEditableVersionDescription$key = {
  readonly " $data"?: async_softwareReleasesVersionDetail_AsyncEditableVersionDescription$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetail_AsyncEditableVersionDescription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesVersionDetail_AsyncEditableVersionDescription",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "FragmentSpread",
      "name": "editableVersionDescription_softwareReleasesVersionDetail"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "26e7d138dfe94f445a25e4067355faac";

export default node;
